export default __webpack_public_path__ + "static/media/downArrow.c28e793f.svg";